import gql from 'graphql-tag';

export const GET_BROADCAST_BY_ID = gql`
  query BroadcastById($broadcastId: ID!) {
    broadcast {
      broadcastById(broadcastId: $broadcastId) {
        broadcastId
        accountId
        type
        title
        body
        status
        effectiveDateTime
        createdDateTime
        attachments {
          broadcastAttachmentId
          name
          source
        }
        account {
          name
          logo
        }
        broadcastAudience {
          audienceType
        }
      }
    }
  }
`;
